<div class="aside-menu">
  <div class="aside-menu-wrapper">
    <ng-content></ng-content>
  </div>
</div>
